/**
 * Vat Rates Module
 */
 (function(){
    'use strict';

    angular.module('elogbooks.admin.vat-rates', []);
})();